import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import SelectByIdTable from './selectByIdTable';

// Pass any array of objects that have an id key field. Also need a name field to display
// Pass the action required to update the store entries.
// Pass the action required to perform the final update.

const SelectByIdModal = (props) => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);

    const toggle = () => {
        setModal(!modal);
    };

    const {
        modalTitle,
        onUpdateHandler,
        onSelectRowHandler,
        onClickButtonHandler,
        className,
        selectLoader,
        data,
        width,
        actionButtonTextId,
    } = props;
    return (
        <Fragment>
            <Button size="sm" color="primary"
                onClick={() => {
                    dispatch(onClickButtonHandler());
                    toggle();
                }}>
                <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                <span>{actionButtonTextId}</span>
            </Button>
            <Modal isOpen={modal} toggle={() => toggle()} className={className}>
                <Fragment>
                    <ModalHeader>{modalTitle}</ModalHeader>
                    <ModalBody>
                        <div className="modal-box-content">
                            <SelectByIdTable data={data} width={width} dispatchOnClick={onSelectRowHandler} />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button size="sm" color="secondary" onClick={() => toggle()}>Close</Button>
                            <Button size="sm" color="primary"
                                onClick={() => {
                                    selectLoader();
                                    dispatch(onUpdateHandler());
                                    toggle();
                                }}>
                                <span><IntlMessages id="general.updateSelections" /></span>
                            </Button>
                        </div>
                    </ModalFooter>
                </Fragment>
            </Modal>
        </Fragment>
    );
};

export default SelectByIdModal;


// WEBPACK FOOTER //
// ./components/selectByIdModal/index.js